import { gql } from '../types/generated';

export const GET_MEDIA_POLICIES = gql(`
  query mediaPolicies($mediaId: String, $gamePk: String, $date: String) {
    mediaPolicies(mediaId: $mediaId, gamePk: $gamePk, date: $date) {
      ...MediaPolicyFields,
      viewingPolicies {
        ...ViewingPolicyFields
      }
    }
  }
`);

export const GET_AUDIENCES = gql(`
  query audiences {
    audiences {
      href
      authenticated
      match
      type
      details
    }
  }
`);

export const GET_VIEWING_POLICIES = gql(`
  query viewingPolicies {
    viewingPolicies {
      ...ViewingPolicyFields
    }
  }
`);

export const AUDIENCE = gql(`
  query audience($href: String!) {
    audience(href: $href) {
      href
      authenticated
      match
      type
      details
    }
  }
`);

export const ESNI_RULES = gql(`
  query esniRules($status: EsniRuleStatus, $type: EsniRuleType) {
    esniRules(status: $status, type: $type) {
      ...EsniRuleFields
    }
  }
`);
